import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;



export async function saveProduct(data) {
  const res = await axiosInstance.post(`${backendUrl}/api/products`, data);
  return res.data;
}

export async function updateProduct(id, data) {

  const res = await axiosInstance.put(`${backendUrl}/api/products/${id}`, data);
  return res.data;
}

// Fetch Company Types
export async function getProduct(productId) {
  return axiosInstance.get(`${backendUrl}/api/products/${productId}`);
}

export async function fetchProducts() {
     return axiosInstance.get(`${backendUrl}/api/products`);
    }


export async function fetchBasicProducts() {
     return axiosInstance.get(`${backendUrl}/api/products/basic`);
    }


 export const deleteProduct = async (id) => {
  const res = await axiosInstance.delete(`${backendUrl}/api/products/${id}`);
  return res.data;
  };
